import React, { memo, useRef } from "react";
import useFontLoader from "../utils/usefontloader";
import usePropFormatter from "../utils/usepropformatter";
function Textarea(props) {
  const { _props, get } = usePropFormatter(props.block);
  useFontLoader(props.block.props);

  if (!_props) {
    return null;
  }
  return (
    <div
      ref={props.editorRef}
      style={{
        position: "relative",
        visibility: props.block.hidden ? "hidden" : "unset",
        boxShadow: props.block.props.boxShadow,
        flexGrow: props.block.props.flexGrow,
        backgroundColor: props.block.props.backgroundColor,
        ...props.block.props.size,
        ...props.block.props.border,
        ...props.block.props.spacing,
      }}
    >
      <textarea
        placeholder={_props.placeholder}
        disabled={true}
        style={{
          position: "relative",
          resize: "none",
          boxSizing: "border-box",
          width: "100%",
          height: "100%",
          border: 0,
          boxSizing: "border-box",
          backgroundColor: "transparent",

          ...props.block.props.textStyle,
        }}
      />
    </div>
  );
}

export default memo(Textarea);
